var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58958 0.41107C1.26414 0.085633 0.736507 0.0856329 0.41107 0.41107C0.085633 0.736506 0.0856329 1.26414 0.41107 1.58958L4.82183 6.00034L0.411094 10.4111C0.0856571 10.7365 0.0856571 11.2641 0.411094 11.5896C0.736531 11.915 1.26417 11.915 1.58961 11.5896L6.00034 7.17885L10.4111 11.5896C10.7365 11.915 11.2642 11.915 11.5896 11.5896C11.915 11.2642 11.915 10.7365 11.5896 10.4111L7.17885 6.00034L11.5896 1.58958C11.915 1.26415 11.915 0.736508 11.5896 0.411071C11.2642 0.085634 10.7365 0.0856344 10.4111 0.411071L6.00034 4.82183L1.58958 0.41107Z",
    fill: "#33383F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e4965db63434244bbc7187b5aaeb684c.svg";
export { ForwardRef as ReactComponent };